import React, { Fragment } from 'react'
import { useAbout, AboutProps } from './useAbout'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './About.module.scss'

const About: React.FC<AboutProps> = (props: AboutProps) => {
  const { socialMedia, contactSocials, t } = useAbout(props)

  return (
    <div className={`col-lg-6 col-xl-5 ${styles['footer-about']}`}>
      <Link to='/' className='logo d-flex align-items-center'>
        <img src='/img/Logos/logo.png' alt='logo' height={64} />
      </Link>
      <div className={`${styles['footer-contact']} pt-3`}>
        {contactSocials && contactSocials.length ? (
          contactSocials.map((item, index) => {
            return (
              <p
                key={`footer-contact-${item.id}-${index}`}
                className={styles.paragraph}
              >
                {item.name === 'Email' || item.name === 'Phone' ? (
                  <span>
                    <FontAwesomeIcon
                      icon={[
                        'fas',
                        item.name === 'Email' ? 'envelope' : 'phone',
                      ]}
                      style={{ marginInlineEnd: '8px' }}
                    />
                    <a
                      dir='ltr'
                      href={item.url}
                      className='text-white text-decoration-none text-hover-secondary transition-0-4'
                    >
                      {item.displayText}
                    </a>
                  </span>
                ) : (
                  item.displayText
                )}
              </p>
            )
          })
        ) : (
          <div className='col-12 text-center fs-4 fw-bold'>{t('noData')}</div>
        )}
      </div>
      <div className={`${styles['social-links']} d-flex mt-4 mb-4 mb-lg-0`}>
        {socialMedia && socialMedia.length ? (
          socialMedia.map((thePlatform, index) => (
            <a
              key={`social-media-${thePlatform.id}-${index}`}
              href={thePlatform.url}
              className={styles.link}
              target='_blank'
              referrerPolicy='no-referrer'
              title={thePlatform.platform}
            >
              <FontAwesomeIcon
                icon={[thePlatform.iconPrefix || 'fas', thePlatform.icon]}
              />
            </a>
          ))
        ) : (
          <Fragment />
        )}
      </div>
    </div>
  )
}

export default About
